const CANCELLED_PATTERNS = [
  /assistant run cancelled/i,
  /cancelled-before-start/i,
  /cancelled-during-execution/i,
];

const TENANT_SCOPE_PATTERNS = [
  /impersonation tenant-claim propagation regression/i,
  /requires tenant scope/i,
  /cannot verify assistant tenant scope/i,
];

const INTERNAL_FAILURE_PATTERNS = [
  /not authorized to perform/i,
  /bedrock:invoke(model|modelwithresponsestream)/i,
  /inference-profile/i,
  /foundation-model/i,
  /admissions store tables are not configured/i,
  /financial aid applications table is not configured/i,
  /runtime policy/i,
  /validationexception/i,
  /unrecognized key/i,
  /expressionattributenames/i,
  /accessdenied/i,
  /arn:aws:/i,
  /assumed-role\//i,
];

export const toUserSafeAssistantErrorMessage = (error: unknown): string => {
  const rawMessage = (
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : ''
  ).trim();

  if (CANCELLED_PATTERNS.some((pattern) => pattern.test(rawMessage))) {
    return 'Assistant run cancelled.';
  }

  if (TENANT_SCOPE_PATTERNS.some((pattern) => pattern.test(rawMessage))) {
    return 'Assistant could not verify the active school for this session. Refresh impersonation or reselect the school context, then try again.';
  }

  if (!rawMessage || INTERNAL_FAILURE_PATTERNS.some((pattern) => pattern.test(rawMessage))) {
    return 'Assistant could not complete this request right now. The issue has been logged.';
  }

  return 'Assistant could not complete this request right now. Please try again.';
};
